import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import { Row, Col, Card } from 'react-bootstrap';
import ListingActionsAwaitingPaymentReport from 'components/ListingActionsAwaitingPaymentReport';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DashboardOutlined } from '@material-ui/icons';
import ExportTable from 'components/ExportTable';

const ActionsAwaitingPayment = () => {
  const defaultFilters = {
    __search: '',
    per_page: 10,
    page: 1,
    status_id: '17,18',
    __aging_min: 0,
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({ data: [], pagination: {} });
  const [load, setLoad] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setLoad(true);
    api.get('actions', { params: { ...filters } }).then(({ data }) => {
      setReports(data);
      setLoad(false);
    });
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:actions awaiting payment')}</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <ExportTable
                  buttonText={t('label:export')}
                  fileName="Report Actions Awaiting Payment"
                  data={async (filters) => {
                    let filters_aux = { ...filters };
                    let _r = await (api.get('actions', { params: { ...filters_aux } }));
                    return _r;
                  }}
                  table={(reports) => {
                    return (
                      <ListingActionsAwaitingPaymentReport
                        reports={{data:reports}}
                        returnTable={true}
                        load={false}
                      />
                    );
                  }}
                  filters={filters}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ListingActionsAwaitingPaymentReport
                  load={load}
                  filters={[]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  reports={reports}
                  handleFilterChange={handleFilterChange}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

export default MasterPage(ActionsAwaitingPayment);
